import cx from 'classnames';
import * as React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { SelectCallback } from 'react-bootstrap';

import type { Repository } from '../../../types';

import styles from './BranchDropdown.module.less';

type BranchDropdownProps = {
  repo?: Repository;
  onBranchChange: Function;
};

const BranchDropdown = (props: BranchDropdownProps) => {
  const changeBranch = (branch: string, event: React.SyntheticEvent<object>) => {
    event.stopPropagation();
    event.preventDefault();
    props.onBranchChange(props.repo, branch);
  };

  const menuItems = props.repo?.branches?.map((branch) => (
    <MenuItem className="branch-item" eventKey={branch} key={branch}>
      {branch}
    </MenuItem>
  ));
  return (
    <span className="branch-dropdown">
      <DropdownButton
        className={cx(styles.dropdownButton)}
        id="serviceImportDropdownButton"
        onSelect={changeBranch as SelectCallback}
        onClick={(e) => {
          // Prevent the event's default so that the parent table row can
          // notice and avoid selecting the repository.
          e.preventDefault();
        }}
        title={
          (
            <span>
              <b>{props.repo?.branch}</b>
            </span>
          )
        }
        pullRight>
        {menuItems}
      </DropdownButton>
    </span>
  );
};

export default BranchDropdown;
